<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <button class="btn btn-sm btn-default btn-novo" @click="atualizar()" style="width: 33px" data-tooltip="Atualizar"><i class="fa fa-refresh" aria-hidden="true"></i></button>
        &nbsp;
        <button class="btn btn-sm btn-primary btn-novo" @click="novo()" style="width: 33px" data-tooltip="Novo"><i class="fa fa-plus" aria-hidden="true"></i></button>
      </div>
    </div>

    <vuetable
      v-if="showTable"
      ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-default': props.rowData.idc_status === 1,
            'label-warning': props.rowData.idc_status === 2,
            'label-info': props.rowData.idc_status === 3,
            'label-success': props.rowData.idc_status === 4,
            'label-danger': [5,9].includes(props.rowData.idc_status)
          }">{{ props.rowData.status_desc }}</span>
      </template>

      <template slot="cliente_detalhe" slot-scope="props">
        {{ props.rowData.client_id ? getClienteDesc(props.rowData.client_id) : '-' }}
      </template>

      <template slot="agencia_detalhe" slot-scope="props">
        {{ props.rowData.agency_id ? getAgenciaDesc(props.rowData.agency_id) : '-' }}
      </template>

      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-xs btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
            <a @click="editar(props.rowData)" class="btn btn-xs btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
          </div>
        </div>
      </template>
    </vuetable>

    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'
import moment from 'moment'

import ActionsLogin from '../../actions/LoginActions'
import CampanhasActions from '../../actions/CampanhasActions'

export default {
  name: 'listar',
  props: ['titulo', 'status'],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      showTable: false,
      css: VuetableCss,
      filterText: '',
      urlApi: '',
      fields: [
        {
          name: 'os_number',
          title: 'Num. OS',
          sortField: 'os_number'
        },
        {
          name: 'cod_op',
          title: 'Código',
          sortField: 'cod_op'
        },
        {
          name: 'client_id',
          title: 'Cliente',
          sortField: 'client_id',
          callback: 'getClienteDetalhe'
        },
        {
          name: 'agency_id',
          title: 'Agência',
          sortField: 'agency_id',
          callback: 'getAgenciaDetalhe'
        },
        {
          name: 'type',
          title: 'Tipo',
          sortField: 'type'
        },
        {
          name: 'pi_number',
          title: 'Número PI',
          sortField: 'pi_number'
        },
        {
          name: 'start_date',
          title: 'Início',
          sortField: 'start_date',
          callback: 'formatarData'
        },
        {
          name: 'end_date',
          title: 'Fim',
          sortField: 'end_date',
          callback: 'formatarData'
        },
        {
          name: 'seller',
          title: 'Vendedor',
          sortField: 'seller'
        },
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'os_number', direction: 'desc' }
      ],
      moreParams: {},
      clients: [],
      agencies: []
    }
  },
  mounted () {
    this.onLoading()
    this.$parent.$parent.$data.description = this.titulo

    this.listClients()
      .then(() => {
        this.urlApi = `${process.env.URL_API_BASE}/campanha-cliente${((this.status !== null && this.status !== undefined) ? (`/listar-por-status/${this.status}`) : '')}`
        this.showTable = true
      })

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  methods: {
    editar (rowData) {
      this.$router.push(`/campanhas/${rowData.cd_campanha}/e`)
    },
    view (rowData) {
      this.$router.push('/campanhas/' + rowData.cd_campanha)
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    atualizar () {
      this.doFilter()
    },
    novo () {
      this.$router.push('/campanhas/novo')
    },
    formatarData (val) {
      let date = moment.utc(val)
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      }
      return ''
    },
    getClienteDetalhe (id) {
      if (id) {
        let row = this.clients.find((i) => i.id === id)
        if (row) {
          return row.company
        }
      }
      return '-'
    },
    getAgenciaDetalhe (id) {
      if (id) {
        let row = this.agencies.find((i) => i.id === id)
        if (row) {
          return row.company
        }
      }
      return '-'
    },
    listClients () {
      this.onLoading()

      return CampanhasActions
        .listClients()
        .then(res => {
          this.clients = res.filter((i) => i.type === 1)
          this.agencies = res.filter((i) => i.type === 2)
          this.onLoaded()
        })
        .catch((error) => {
          console.log(error.response.data.message)
          this.errorMessage = error.response.data.message
          this.onLoaded()
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/campanhas/Listar.vue